import { Expose, Type } from 'class-transformer';
import { RefreshTokensResponseDto } from './refresh-tokens.response.dto';

export class RefreshTokenResponseDto {
  @Expose({ name: 'tokens' })
  @Type(() => RefreshTokensResponseDto)
  tokens: RefreshTokensResponseDto;
}
